export default "__VITE_PUBLIC_ASSET__696f6347__"